<template>
  <div class="my-info-page">
    <div
      @click="jumpPage('UserInfo')"
      class="user-info-wrap"
      v-if="isAuthenticated"
    >
      <img class="avatar" :src="user.avatar" alt="" />
      <div class="user-info">
        <span class="nickname">{{ user.nickname }}</span>
        <span class="user-id">ID:{{ user.user_id }}</span>
      </div>
      <img
        @click="jumpPage('MsgList')"
        class="msg-icon"
        src="../../assets/img/my-info/msg-icon.png"
        alt=""
      />
    </div>
    <div v-else @click="jumpPage('UserInfo')" class="user-info-wrap">
      <img
        class="avatar"
        :src="notLoginAvatar"
        alt=""
      />
      <div class="user-info">
        <span class="nickname">立即登录</span>
        <span class="user-id">登录后，学习更过课程</span>
      </div>
    </div>
    <!-- 菜单 -->
    <div class="menu-list">
      <router-link
        v-for="item in menuList"
        :key="item.id"
        :to="{ name: item.name }"
        class="menu-item"
      >
        <p class="left">
          <img class="icon" :src="item.image" alt="" />
          <span class="name">{{ item.text }}</span>
        </p>
        <img
          class="arrow-right"
          src="../../assets/img/my-info/arrow-right.png"
          alt=""
        />
      </router-link>
    </div>
    <!-- 退出登录 -->
    <div v-if="isAuthenticated" class="login-out" @click="logout">退出登录</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getMoguoCdnUrl } from "@saas/components/src/utils/assets";
export default {
  data: function () {
    return {
      menuList: [
        {
          id: 1,
          text: "交易记录",
          name: "Trade",
          image: require("../../assets/img/my-info/trade-icon.png"),
        },
        {
          id: 2,
          text: "课程兑换",
          name: "Exchange",
          image: require("../../assets/img/my-info/exchage-icon.png"),
        },
      ],
    };
  },
  methods: {
    logout() {
      this.$chiralConfirmLoading(`是否确认退出账号`, "确定", (val) => {
        if (val) {
          this.$store.dispatch("clearProfile");
        }
      });
    },
    jumpPage(name) {
      this.$router.push({ name });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    notLoginAvatar() {
      return getMoguoCdnUrl("/cdn/static/images/not-login-avatar.png");
    },
  },
};
</script>

<style lang="scss" scoped>
.my-info-page {
  height: calc(100vh - #{$h5-footer-height});
  background: #f5f5f6;
  padding: 0.64rem 0.32rem 0;
  .user-info-wrap {
    // background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%);
    display: flex;
    align-items: center;
    position: relative;
    .msg-icon {
      position: absolute;
      right: 0.32rem;
      top: 50%;
      transform: translateY(-50%);
      width: 0.52rem;
      height: 0.52rem;
    }
    .avatar {
      width: 1.33rem;
      height: 1.33rem;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 0.21rem;
    }
    .user-info {
      display: flex;
      flex-direction: column;
      //   justify-content: ;
    }
    .nickname {
      font-weight: 500;
      font-size: 0.53rem;
      color: #222426;
      line-height: 0.64rem;
      margin-bottom: 0.16rem;
    }
    .user-id {
      font-size: 0.32rem;
      color: #747573;
      line-height: 0.37rem;
    }
  }
  .menu-list {
    margin-top: 0.64rem;
    width: 100%;
    background: #ffffff;
    border-radius: 0.32rem;
    padding: 0 0.43rem 0 0.37rem;
  }
  .menu-item {
    &:last-child {
      border-bottom: none;
    }
    border-bottom: 1px solid #f5f5f5;
    padding: 0.48rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
    }
    .icon {
      width: 0.53rem;
      height: 0.53rem;
      margin-right: 0.16rem;
    }
    .name {
      font-weight: 400;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 1;
    }
    .arrow-right {
      width: 0.37rem;
      height: 0.37rem;
    }
  }
  .login-out {
    position: fixed;
    bottom: calc(0.37rem + #{$h5-footer-height});
    left: 50%;
    transform: translateX(-50%);
    width: 9.36rem;
    height: 1.39rem;
    background: #ffffff;
    border-radius: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 0.4rem;
    color: #515350;
    line-height: 0.56rem;
  }
}
</style>
